import { render } from "./Bye.vue?vue&type=template&id=f6ce0fbc&scoped=true"
import script from "./Bye.vue?vue&type=script&lang=js"
export * from "./Bye.vue?vue&type=script&lang=js"

import "./Bye.vue?vue&type=style&index=0&id=f6ce0fbc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ce0fbc"]])

export default __exports__